import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const ElectronicDocumentRequest = {
  getElectronicDocumentList: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/electronic-document`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: params,
    }),

  createElectronicDocument: dataSubmit =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/electronic-document`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: dataSubmit,
    }),

  getElectronicDocumentById: code =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/electronic-document/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  updateElectronicDocumentStatus: (data, code) =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/electronic-document/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),

  /** Trả hồ sơ định hướng về Bước 1 hoặc 2 (bắt buộc lý do) */
  rollbackElectronicDocument: (code, data) =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/electronic-document/${code}/rollback`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data,
    }),

  /** Giám đốc mở lại luồng trình ký sau khi khóa */
  unlockElectronicDocument: (code, data = {}) =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/electronic-document/${code}/unlock`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data,
    }),

  updateFileElectronic: (file_id, action, code) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/electronic-document/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: {
        file_id: file_id,
        action: action,
      },
    }),

  updateElectronicDocument: (code, data) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/electronic-document/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),

  updateElectronicAnnexDocument: (code, data) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/electronic-document/${code}/annex`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),

  deleteElectronicDocument: code =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/electronic-document/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  // comment
  getCommentElectronicDocumentList: code =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/electronic-document/${code}/comments`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  createCommentElectronicDocument: (code, data) =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/electronic-document/${code}/comments`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),

  deleteCommentElectronicDocument: (code, id_comment) =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/electronic-document/${code}/comments/${id_comment}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  //assign person
  updateAssignees: (code, assignees) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/electronic-document/${code}/assign-person`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: assignees,
    }),

  updateManagerSignedNote: (assignee, documentCode) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/electronic-document/update-note`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: {
        assignee,
        documentCode,
      },
    }),

  // delete note
  deleteNote: (documentCode, permission) =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/electronic-document/delete-note`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: {
        documentCode,
        permission,
      },
    }),

  updateSignedFile: data =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/electronic-document/${data.document_code}/signed-file`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: {
        documentCode: data.document_code,
        mainFiles: data.main_files,
        signedFileIndex: data.signed_file_index,
        originalFileId: data.original_file_id,
        newFileId: data.new_file_id,
        signStep: data.sign_step,
      },
    }),

  updateSignedFilesBatch: (documentCode, items) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/electronic-document/${documentCode}/signed-file/batch`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: {
        items: items.map(item => ({
          documentCode: item.document_code || documentCode,
          mainFiles: item.main_files,
          signedFileIndex: item.signed_file_index,
          originalFileId: item.original_file_id,
          newFileId: item.new_file_id,
          signStep: item.sign_step,
        })),
      },
    }),
}
